(function () {
    'use strict';
    var controllerId = 'profiloImage';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'common', '$uibModalInstance', 'profilo', '$translate', profiloImageFn]);

    function profiloImageFn($scope, datacontext, common, $uibModalInstance, profilo, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");

        $scope.profilo = profilo;
        $scope.item = {};
        $scope.item.Icona = profilo.Icona;

        $scope.setIcon = setIcon;
        $scope.setColor = setColor;

        toggleFace();
        toggleColor();

        $scope.ok = function () {
            datacontext.risorsa_setIcona($scope.item.Icona).then(function (data) {
                if (data == '200') {                    
                    $uibModalInstance.close($scope.item.Icona);
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };

        function setIcon(value) {
            var color = $scope.item.Icona.substring(1, 2);
            if (!color || color == undefined)
                color = '0';

            $scope.item.Icona = value + color;
            toggleFace();
        }

        function setColor(value) {
            var face = $scope.item.Icona.substring(0, 1);
            if (!face || face == undefined)
                face = '0';

            $scope.item.Icona = face + value;
            toggleColor();
        }

        function toggleFace() {
            $scope.item.faceOneActive = false;
            $scope.item.faceTwoActive = false;
            $scope.item.faceThreeActive = false;
            $scope.item.faceFourActive = false;
            $scope.item.faceFiveActive = false;
            $scope.item.faceSixActive = false;
            $scope.item.faceSevenActive = false;

            var i = $scope.item.Icona.substring(0, 1);
            switch (i) {
                case '1': $scope.item.faceOneActive = true;
                    break;
                case '2': $scope.item.faceTwoActive = true;
                    break;
                case '3': $scope.item.faceThreeActive = true;
                    break;
                case '4': $scope.item.faceFourActive = true;
                    break;
                case '5': $scope.item.faceFiveActive = true;
                    break;
                case '6': $scope.item.faceSixActive = true;
                    break;
                case '7': $scope.item.faceSevenActive = true;
                    break;
                default: $scope.item.faceOneActive = true;
                    break;
            }
        }

        function toggleColor() {
            $scope.item.colorOneActive = false;
            $scope.item.colorTwoActive = false;
            $scope.item.colorThreeActive = false;
            $scope.item.colorFourActive = false;
            $scope.item.colorFiveActive = false;
            $scope.item.colorSixActive = false;
            $scope.item.colorSevenActive = false;

            var i = $scope.item.Icona.substring(1, 2);
            switch (i) {
                case '1': $scope.item.colorOneActive = true;
                    break;
                case '2': $scope.item.colorTwoActive = true;
                    break;
                case '3': $scope.item.colorThreeActive = true;
                    break;
                case '4': $scope.item.colorFourActive = true;
                    break;
                case '5': $scope.item.colorFiveActive = true;
                    break;
                case '6': $scope.item.colorSixActive = true;
                    break;
                case '7': $scope.item.colorSevenActive = true;
                    break;
                default: $scope.item.colorOneActive = true;
                    break;
            }
        }
    }
})();